<template>
    <v-layout align-center justify-center class="upload_bg">
        <v-toolbar fixed flat class="transparent white--text">
            <span>SweldoNow Upload Photo</span>
            <v-spacer></v-spacer>
            <v-toolbar-items>       
                <v-btn dark flat @click="closeDialog">Close</v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-flex xs12 sm7>  
            <v-alert v-if="error"  :value="networkError" type="error" icon="error" dismissible>
                {{ errorMessage }}
            </v-alert>
            <v-alert :value="networkError" type="error" icon="error" dismissible>
                Upload Picture failed due to network error. Please check your internet connection then retry again.
            </v-alert>
            <div>
                <vue-dropzone ref="myVueDropzone" 
                    style="height:300px;padding:0px 50px 0px 50px;"
                    id="dropzone" 
                    :options="dropzoneOptions"
                    v-on:vdropzone-success="uploadSuccess"
                    v-on:vdropzone-file-added="fileAdded"
                    ></vue-dropzone>
            </div>
        </v-flex> 
    </v-layout>
 </template>
 <script>
     
 import axios from 'axios'
 import vue2Dropzone from 'vue2-dropzone'
 import 'vue2-dropzone/dist/vue2Dropzone.min.css'
 import pageKeys from '@/common/pagekeys'
 
 export default {
    name: 'edit-team',
    components: {
        vueDropzone: vue2Dropzone
    },
    data () {
        return {
            userId: 0,
            loading: false,   
            img: null,
            video: null,          
            dropzoneOptions: {                    
                url: `${axios.defaults.baseURL}Image/upload/faceai-training-photo`,    
                headers: { 
                    "Authorization": `Bearer ${localStorage.token}`,
                    "page_key": pageKeys.attendance_face_activation,
                    "session_id": localStorage.sessionId,
                    "source": "Customer"
                },
                addRemoveLinks: true,
                dictDefaultMessage: "<p class='subheading'><u>Drop your photo here or click to browse gallery</u></p><br><p class='body-1 text-xs-left'><b>IMPORTANT:</b></p><ul class='text-xs-left'><li>File Type: JPG only</li><li>Dimensions: Around 2x2 inches and 1680x1680 pixels</li><li>File Size: Must be between 500KB to 600KB only</li></ul><br><p class='text-xs-left'><b>TIP: </b>Use MS Paint to crop the photo to show only your face.</p>",
                maxFiles: 1,
                acceptedFiles: 'image/jpeg', 
                maxFilesize: 0.6,   //600kb
            },
            networkError: false,
            uploading: false,
            error: false,
            errorMessage: '', 
        }
    },
    props: ['pageKey'],
    methods: {
        fileAdded(file) {
            this.loading = true
        },
        async uploadSuccess(file, response) {
            this.$refs.myVueDropzone.removeAllFiles()
            this.$emit('send', response)
            this.closeDialog()
        },
        closeDialog() {
            this.$emit('update:dialogUploadPhoto', false)   
        }
    },        
    created() {
        this.dropzoneOptions = {  
            url: `${axios.defaults.baseURL}Image/upload/faceai-training-photo`,    
            headers: { 
                "Authorization": `Bearer ${localStorage.token}`,
                "page_key": this.pageKey,
                "session_id": localStorage.sessionId,
                "source": "Customer"
            },
            addRemoveLinks: true,
            dictDefaultMessage: "<p class='subheading'><u>Drop your photo here or click to browse gallery</u></p><br><p class='body-1 text-xs-left'><b>IMPORTANT:</b></p><ul class='text-xs-left'><li>File Type: JPG only</li><li>Dimensions: Around 2x2 inches and 1680x1680 pixels</li><li>File Size: Must be between 500KB to 600KB only</li></ul><br><p class='text-xs-left'><b>TIP: </b>Use MS Paint to crop the photo to show only your face.</p>",
            maxFiles: 1,
            acceptedFiles: 'image/jpeg', 
            maxFilesize: 0.6,   //600kb
        }
    }
 }
 </script>
 <style scoped>
 .upload_bg {
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: rgba(0, 0, 0, 0.9)
 }
 </style>